import { render, staticRenderFns } from "./activityBlock.vue?vue&type=template&id=1f41465f&scoped=true&"
import script from "./activityBlock.js?vue&type=script&lang=js&"
export * from "./activityBlock.js?vue&type=script&lang=js&"
import style0 from "./activityBlock.vue?vue&type=style&index=0&id=1f41465f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f41465f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f41465f')) {
      api.createRecord('1f41465f', component.options)
    } else {
      api.reload('1f41465f', component.options)
    }
    module.hot.accept("./activityBlock.vue?vue&type=template&id=1f41465f&scoped=true&", function () {
      api.rerender('1f41465f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/activityBlock.vue"
export default component.exports